<script setup lang="ts"></script>

<template>
  <icon name="icon-park-outline:add-picture" />
</template>

<style scoped></style>
